import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Icon from "@/components/Icon";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background grain px-6" data-testid="admin-login">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm relative z-10"
      >
        <div className="inline-flex items-center gap-2 text-accent">
          <Icon name="Lock" size={20} weight="duotone" />
          <span className="overline text-foreground/60">Owner Access</span>
        </div>
        <h1 className="font-display text-5xl tracking-tight mt-6 text-foreground">Sign in</h1>
        <p className="text-muted-foreground mt-3 text-sm">
          Manage the guidebook for Via Solana.
        </p>

        <form onSubmit={submit} className="mt-10 space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email" className="overline text-foreground/50">Email</Label>
            <Input
              id="email"
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none border-0 border-b-2 border-foreground/20 bg-transparent px-0 focus-visible:ring-0 focus-visible:border-accent text-lg h-12"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="overline text-foreground/50">Password</Label>
            <Input
              id="password"
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none border-0 border-b-2 border-foreground/20 bg-transparent px-0 focus-visible:ring-0 focus-visible:border-accent text-lg h-12"
              required
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-destructive text-sm">{error}</p>
          )}

          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-foreground text-primary-foreground py-4 rounded-full text-sm font-semibold hover:bg-accent transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <a href="/" className="inline-block mt-10 text-xs text-muted-foreground link-underline">
          ← Back to guidebook
        </a>
      </motion.div>
    </div>
  );
}
